// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrow_wrapper__328N4","img":"Arrow_img__26ckF","left":"Arrow_left__2BV0A","right":"Arrow_right__uot2A","show":"Arrow_show__90z08","hide":"Arrow_hide__e_wYg"};